import {
  FETCH_EVENTS_SUCCESS,
  FETCH_EVENTS_LOADING,
  FETCH_EVENTS_ERROR,
  EVENT_OTHER_FILTERS,
  FILTER_BY_DATE,
  FILTER_BY_USERS,
  APPLY_USER_FILTER,
  APPLY_DATE_FILTER,
  FILTER_BY_EVENT_TYPES,
  ON_FILTER_CHANGE,
  ON_CALENDAR_CHANGE,
  APPLY_EVENT_FILTER,
  ON_CANCEL_EVENT,
  ON_DETAIL_EXPAND,
  ON_CHANGE_ACTIVE_TAB,
  RESET_FILTER,
  ON_PAGE_CHANGE,
  FETCH_USER_SUCCESS,
  FETCH_EVENT_LIST_SUCCESS
} from './actionTypes';
export const initialState = {
  eventType: 'upcoming',
  range: false,
  filter: false,
  default: null,
  selectedRange: [],
  eventSelected: [],
  usersSelected: [],
  usersVisible: false,
  eventVisible: false,
  expandId: null,
  email: null,
  loading: false,
  totalCount: 0,
  responseCount: 0,
  currentPage: 1,
  pageSize: 20,
  activeTab: '1',
  isActive: true,
  users: [],
  events_type: [],
  booked_events: []
};

export const eventReducer = (state = initialState, action) => {
  switch (action.type) {
    case RESET_FILTER: {
      return { ...initialState };
    }
    case FETCH_EVENTS_LOADING:
      return { ...state, loading: true };

    case FETCH_EVENTS_SUCCESS:
      return {
        ...state,
        booked_events: action.payload.events,
        totalCount: action.payload.total,
        responseCount: action.payload.responseCount,
        loading: false
      };

    case FETCH_EVENTS_ERROR:
      return {
        ...state,
        loading: false,
        booked_events: [],
        totalCount: 0,
        responseCount: 0
      };

    case FILTER_BY_DATE:
      return { ...state, range: !state.range, filter: false };

    case EVENT_OTHER_FILTERS:
      return { ...state, range: false, eventVisible: false, usersVisible: false, filter: !state.filter };

    case FILTER_BY_USERS:
      return { ...state, usersVisible: !state.usersVisible, eventVisible: false };

    case APPLY_USER_FILTER:
      return { ...state, usersVisible: false, eventVisible: false };

    case APPLY_EVENT_FILTER:
      return { ...state, usersVisible: false, eventVisible: false, range: false, filter: false };

    case FILTER_BY_EVENT_TYPES:
      return { ...state, eventVisible: !state.eventVisible, usersVisible: false };

    case ON_FILTER_CHANGE:
      return { ...state, [action.payload.name]: action.payload.value };

    case APPLY_DATE_FILTER:
      return { ...state, range: false, activeTab: action.payload, eventType: null };

    case ON_CALENDAR_CHANGE:
      return { ...state, selectedRange: action.payload };

    case ON_CANCEL_EVENT:
      return { ...state, [action.payload.name]: [], eventVisible: false, usersVisible: false };

    case ON_DETAIL_EXPAND: {
      if (action.payload === state.expandId) {
        return { ...state, expandId: null };
      }
      return { ...state, expandId: action.payload };
    }

    case ON_CHANGE_ACTIVE_TAB: {
      if (parseFloat(action.payload) === 3) {
        return { ...state };
      } else {
        if (parseFloat(action.payload) === 1) {
          return { ...state, activeTab: action.payload, selectedRange: [], eventType: 'upcoming' };
        } else if (parseFloat(action.payload) === 2) {
          return { ...state, activeTab: action.payload, selectedRange: [], eventType: 'past' };
        }
      }
      break;
    }

    case ON_PAGE_CHANGE: {
      return { ...state, currentPage: action.payload };
    }

    case FETCH_USER_SUCCESS: {
      return { ...state, users: action.payload };
    }

    case FETCH_EVENT_LIST_SUCCESS: {
      return { ...state, events_type: action.payload };
    }

    default:
      return state;
  }
};
